import axios from "axios";

class API {
    constructor(token) {
        this.token = token;
        
        // Add response interceptor to handle 401 errors
        this.setupInterceptors();
    }

    setupInterceptors() {
        // Add response interceptor to handle token expiration
        axios.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response && error.response.status === 401) {
                    // Token is invalid or expired
                    localStorage.removeItem('authToken');
                    // Redirect to homepage which will trigger re-authentication
                    window.location.href = '/';
                }
                return Promise.reject(error);
            }
        );
    }

    get(url, customHeaders = {}) {
        let headers = {
            'Authorization': 'Bearer ' + this.token,
            ...customHeaders
        }
        return axios.get(
            url, {
                headers: headers
            }
        )
    }

    patch(url, body, contentType, customHeaders = {}) {
        let headers = {
            'Authorization': 'Bearer ' + this.token,
            ...customHeaders
        }
        if(contentType && contentType !== "multipart/form-data") {
            headers["Content-Type"] = contentType
        }
        return axios.patch(url, body, {
            headers: headers
        })
    }

    post(url, body, contentType, customHeaders = {}) {
        let headers = {
            'Authorization': 'Bearer ' + this.token,
            ...customHeaders
        }
        if(contentType && contentType !== "multipart/form-data") {
            headers["Content-Type"] = contentType
        }
        return axios.post(url, body, {
            headers: headers
        })
    }

    delete(url, customHeaders = {}) {
        let headers = {
            'Authorization': 'Bearer ' + this.token,
            ...customHeaders
        }
        return axios.delete(
            url, {
                headers: headers
            }
        )
    }
}

export default API;